<template>
  <v-dialog
    v-model="show"
    max-width="560"
    scrollable
  >
    <v-card color="secondary">
      <v-card-title>
        <v-spacer />
        {{ __('settings') }}
        <v-spacer />
      </v-card-title>
      <v-card-text class="px-0">
<template v-if="$page.props.brand === 'HANDY'"><!-- TEMPORAL condition -->
        <v-select
          v-model="locale"
          :label="__('language')"
          :items="locales"
          :prepend-icon="icons.locale"
          menu-props="light"
          class="mx-2 mt-2"
        />
        <v-divider />
</template>
        <v-list
          subheader
          color="secondary"
        >
          <v-subheader class="text-uppercase">
            <v-icon small left color="primary" v-text="icons.order" />
            {{ __('configOrder') }}
          </v-subheader>
          <h-switch
            v-model="settings.rememberDishOrder"
            :label="__('rememberDishOrder')"
          />
          <h-switch
            v-if="$page.props.brand === 'HANDY'"
            v-model="settings.keepOrdersOpen"
            :label="__('keepOrdersOpen')"
          />
        </v-list>
        <v-divider />
        <v-list
          subheader
          color="secondary"
        >
          <v-subheader class="text-uppercase">
            <v-icon small left color="primary" v-text="icons.menu" />
            {{ __('configMenu') }}
          </v-subheader>
          <h-switch
            v-model="settings.fastMenuEntry"
            :label="__('fastMenuEntry')"
          />
          <h-switch
            v-model="settings.hideMenuContents"
            :label="__('hideMenuContents')"
          />
        </v-list>
        <v-divider />
        <v-select
          v-model="settings.tablePriceId"
          :label="__('rate')"
          :items="tablePrices"
          item-value="id"
          item-text="name"
          :prepend-icon="icons.percent"
          :disabled="tablePrices.length <= 1"
          menu-props="light"
          class="mx-2 mt-2"
        />
        <v-select
          v-model="settings.cashier"
          :label="__('cashier')"
          :items="cashiers"
          item-value="id"
          item-text="name"
          :prepend-icon="icons.cashier"
          :disabled="cashiers.length <= 1"
          menu-props="light"
          class="mx-2 mt-2"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          text
          color="grey lighten-1"
          @click="show = false"
        >
          {{ __('cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="save()"
        >
          {{ __('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ChangesLocale from '@/Mixins/ChangesLocale'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HSwitch from './Switch'

  export default {
    mixins: [
      ChangesLocale,
      I18n,
      UsesIcons,
    ],

    components: {
      HSwitch,
    },

    data: () => ({
      locale: 'en',
      settings: {},
    }),

    computed: {
      tablePrices () {
        return this.$store.getters['rummage/tablePrices']
      },
      cashiers () {
        return this.$store.getters['rummage/cashiers']
      },
      show: {
        get () {
          return this.$store.state.settings.show
        },
        set (v) {
          this.$store.commit(v ? 'settings/show' : 'settings/hide')
        },
      },
    },

    watch: {
      show (v) {
        if (v) {
          this.locale = this.$store.state.locale
          this.settings = {...this.$store.state.settings.values}
          this.settings.tablePriceId = this.$store.getters['rummage/tablePrice']?.id
          this.settings.cashier = this.$store.getters['rummage/cashier']?.id
        }
      },
    },

    methods: {
      save () {
        this.changeLocale(this.locale)
        this.$store.dispatch('settings/save', this.settings)
        this.show = false
      },
    },
  }
</script>
